export const DEFAULT_INSURANCE_CARD_TITLE = "Your insurance card";
export const DEFAULT_INSURANCE_CARD_DESCRIPTION =
  "To use your insurance for your upcoming session, please provide a clear photo of the front of your card.";
export const DEFAULT_INSURANCE_CARD_MANUAL_DESCRIPTION = "Enter your insurance information below.";

export function resolveInsuranceCardDescription(
  showManual: boolean,
  overrideDescription: string | undefined
): string {
  if (overrideDescription) return overrideDescription;
  return showManual ? DEFAULT_INSURANCE_CARD_MANUAL_DESCRIPTION : DEFAULT_INSURANCE_CARD_DESCRIPTION;
}
